import { AuthFetchError, AuthFetchWithResponse } from '@e3dc-react/shell/Types'
import { ApiResult } from 'src/Libs/api/types'
import { handleFetchError } from 'src/Libs/api/utils'
import { ActuatorData, ActuatorPayload } from '../models/smart-home.model'
import { HttpStatusCode } from 'axios'
import { ActuatorDataDto, SmarthomeConfiguredDto } from '../dto/smart-home.dto'
import {
  actuatorDataDtoToModelTransformer,
  smarthomeConfiguredDtoToModelTransformer,
} from '../transformers/smart-home/smart-home-dto-to-model.transformer'
import { actuatorDescriptionsModelToDtoTransformer } from '../transformers/smart-home/smart-home-model-to-dto.transformer'

export const getActuatorList = async (installationId: string, authFetch: AuthFetchWithResponse): Promise<ApiResult<ActuatorData[]>> => {
  try {
    const response = await authFetch<ActuatorDataDto[]>({
      method: 'GET',
      path: `installations/${installationId}/smart-home`,
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })

    if (response.status === HttpStatusCode.Ok) {
      return new ApiResult<ActuatorData[]>(actuatorDataDtoToModelTransformer(response.data), false)
    }

    return new ApiResult<ActuatorData[]>(null, true)
  } catch (error) {
    return new ApiResult<ActuatorData[]>(null, true, error)
  }
}
/**
 * Checks whether smart-home is configured for the installation.
 */
export const getSmarthomeConfiguredState = async (
  installationId: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  try {
    const response = await authFetch<SmarthomeConfiguredDto>({
      method: 'GET',
      path: `installations/${installationId}/smart-home/configured`,
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })

    if (response.status === HttpStatusCode.Ok) {
      return new ApiResult<boolean, AuthFetchError | Error>(smarthomeConfiguredDtoToModelTransformer(response.data), false)
    }

    return new ApiResult<boolean, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}

export const updateFunkActor = async (
  storageId: string,
  funkActorId: number,
  payload: ActuatorPayload,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<void, Error>> => {
  try {
    const response = await authFetch<void>({
      method: 'PUT',
      path: `storages/${storageId}/houseautomation/funk/${funkActorId}`,
      payload: { ...payload, descriptions: payload.descriptions ? actuatorDescriptionsModelToDtoTransformer(payload.descriptions) : undefined },
    })

    if (response.status === HttpStatusCode.NoContent) {
      return new ApiResult<void, Error>(null, false)
    }

    return new ApiResult<void, Error>(null, true)
  } catch (error) {
    const e = error as AuthFetchError

    if (e.status === HttpStatusCode.Forbidden) {
      const error = new Error('smart-home.errors.forbidden')
      return new ApiResult<void, Error>(null, true, error)
    }

    return new ApiResult<void, Error>(null, true, e)
  }
}
